<script>
  import Footer from '../../components/Footer.svelte'
  import TextButton from '../../components/TextButton.svelte'
  import ShareIcons from '../../components/Share/ShareIcons.svelte'
  import DateChannel from '../../components/DateChannel/DateChannel.svelte'

  export let isQna = false
  export let shopUrl
  export let review
  export let toggleShare
  export let currentShareId
  export let shareId
  export let comments = []
  export let toggleComments
  export let commentsText
  export let shareText
  export let shareToText
  export let accountLogo
  export let style
</script>

<Footer {style}>
  {#if !isQna}
    <TextButton hasHover={true} handleClick={toggleShare} fontWeight="normal">
      {shareText}
      <ShareIcons
        {review}
        {shopUrl}
        {currentShareId}
        {shareId}
        {accountLogo}
        {toggleShare}
        {shareToText}
        widgetType="neptune_widget" />
    </TextButton>
  {/if}
  {#if comments.length > 0}
    <TextButton
      handleClick={toggleComments}
      hasHover={true}
      fontWeight="normal">
      {comments.length} {commentsText}
    </TextButton>
  {/if}
  {#if !isQna}
    <DateChannel reviewchannel={review.platform} showIconOnReview={true} />
  {/if}
</Footer>
